import { useEffect } from "react";
import { Link, Outlet, useLoaderData, useLocation, useNavigate, useNavigation } from "react-router";
import LoadingScreen from "./LoadingScreen";
import { User } from "../types";
import { logout } from "../api";
import { BUILD_DATE } from "../build-info";
import UserHeaderPanel from "../features/users/components/UserHeaderPanel";
const logo = new URL("../images/renew-pacific-logo.svg", import.meta.url);

export function HydrateFallback() {
    return <LoadingScreen />;
}

export default function Root() {
    const { user, error } = useLoaderData() as { user: User | null; error: string | null };
    const location = useLocation();
    const navigate = useNavigate();

    // Redirect to dashboard if logged in
    useEffect(() => {
        if (user && !error && location.pathname === '/') {
            navigate('/dashboard');
        }
    }, []);

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    return (
        <div className='h-full w-full p-6 overflow-y-auto no-scrollbar bg-base-100'>
            <title>Performance Monitoring</title>
            <div className='w-full h-full flex flex-col rounded-lg p-4'>
                <div>
                    <div className="flex items-center justify-between">
                        <Link to="/dashboard">
                            <div className="flex items-center">
                                <img className="h-12 mr-4" src={logo.toString()} alt="logo" />
                                <h1 className='font-title font-bold text-3xl text-neutral'>Performance Monitoring</h1>
                            </div>
                        </Link>
                        {user && <UserHeaderPanel user={user} handleLogout={handleLogout} />}
                    </div>
                    {error && (
                        <div className="mt-4 p-3 bg-error border border-error-content text-error-content rounded">
                            {error}
                        </div>
                    )}
                </div>
                {/* Hiding the footer until we get guidance from the client on what content should be there. */}
                <>
                    <Outlet context={{ user: user }} />
                    {/* <footer className="w-full mt-8 py-4">
                            <div className="text-center text-gray-500 text-sm">
                                &copy; {new Date().getFullYear()} REnew Pacific. Developed by ITP Renewables.
                                Build Date: {BUILD_DATE}
                            </div>  
                        </footer> */}
                </>
            </div>
        </div>
    );
}
